import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateCategory } from "../../features/category";

const CategoryCreate = () => {
  const { create } = useCreateCategory();
  const [formData, setFormData] = useState({
    name: "",
  });

  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    create(formData);
    console.log("Category Data Submitted:", formData);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <div className="flex-1 p-8">
        <h1 className="text-xl font-bold text-center mb-8">Create Category</h1>
        <form
          onSubmit={handleSubmit}
          className="max-w-2xl mx-auto bg-white p-6 shadow-md rounded-md"
        >
          <div className="mb-4">
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            >
              Nama
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full mt-6 py-2 px-4 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            Submit
          </button>
          <button
            type="button"
            onClick={() => navigate("/category")}
            className="w-full mt-6 py-2 px-4  bg-gray-400 text-white font-medium rounded-mdfocus:outline-none focus:ring-2 "
          >
            Back
          </button>
        </form>
      </div>
    </div>
  );
};

export default CategoryCreate;
